module.exports = __webpack_public_path__ + "static/img/school_xy.456fbaa.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/product/school_xy.jpg
// module id = ErIu
// module chunks = 1